import React from "react";
import * as styles from "./style.module.scss";
import Menu from "@mui/material/Menu";

const DefaultMenu = ({
  children,
  anchorEl,
  id,
  open,
  onClose,
  classes,
  anchorOrigin,
  transformOrigin,
  keepMounted = true,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      id={id}
      keepMounted={keepMounted}
      open={open}
      onClose={onClose}
      classes={{ paper: `${styles.notificationMenu} ${classes}` }}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
    >
      {children}
    </Menu>
  );
};

export default DefaultMenu;
